import useMap from "../../components/useMap";
import useSelectedFeatures from "../../components/maps/GeoJSONMap/useSelectedFeatures";
import {useGeoJSONModel1Stations} from "../../components/maps/query";


const useModels1Map = ({models1Filters}) => {
    const geoStationQuery = useGeoJSONModel1Stations(models1Filters);
    const stationGeoJSON = geoStationQuery.data ?? {type: "FeatureCollection", features: []};
    const map = useMap();
    const selectedFeatures = useSelectedFeatures({features: stationGeoJSON.features});

    return {
        geoJSON: stationGeoJSON,
        ...map,
        ...selectedFeatures,
    }
}


export default useModels1Map;